import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { InvoiceModel } from '@shared/store/invoice/invoice.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'aux-invoice-detail-title',
  standalone: true,
  template: `
    <div class="flex items-center justify-between">
      <div class="mb-4 text-xl font-bold">
        {{ title() }}
      </div>
      <div></div>
    </div>
  `,
})
export class InvoiceDetailTitleComponent {
  invoice = input.required<InvoiceModel>();

  title = computed(
    () => `${this.invoice().organization.name} - Invoice ${this.invoice().invoice_no || ''}`
  );
}
